<template>
  <main class="error-page">
    <div class="error-page__content has-text-centered">
      <p class="error-page__code">
        {{ statusCode }}
      </p>
      <h1 class="title is-3">
        {{ $t('errorPage.title') }}
      </h1>
      <p class="subtitle is-5">
        {{ $t('errorPage.description') }}
      </p>
      <nuxt-link
        :to="localePath({
          name: 'product',
          params: {
            productName: 'plissee-ohne-bohren',
            productId: 10,
          },
        })"
        class="button is-primary is-medium is-rounded"
      >
        {{ $t('errorPage.plisses') }}
      </nuxt-link>
      <nuxt-link
        :to="localePath({
          name: 'product',
          params: {
            productName: 'schuette-wabenplissee-verdunklungsplissee-ohne-bohren-nach-mas-blackout-x-honey-moonlight-weis',
            productId: 10948,
          },
        })"
        class="button is-primary is-medium is-rounded"
      >
        {{ $t('errorPage.honeycomb') }}
      </nuxt-link>
      <nuxt-link
        :to="localePath({
          name: 'product',
          params: {
            productName: 'schuette-verdunkelungsrollo-ohne-bohren-mit-bohren-2in1-nach-mas-kollektion-thermo-blackout-snowflake',
            productId: 2147,
          },
        })"
        class="button is-primary is-medium is-rounded"
      >
        {{ $t('errorPage.blackout') }}
      </nuxt-link>
      <nuxt-link
        :to="localePath({
          name: 'product',
          params: {
            productName: 'schuette-spannbettlaken-140-x-200-wow-kollektion-fluff-white-weis-100-superfluff-baumwolle',
            productId: 66843,
          },
        })"
        class="button is-primary is-medium is-rounded"
      >
        {{ $t('errorPage.fitted') }}
      </nuxt-link>
    </div>
  </main>
</template>

<script>
export default {
  layout: 'default',
  props: {
    error: {
      type: Object,
      default: null
    }
  },
  head () {
    return {
      title: `${this.statusCode} - ${this.$t('errorPage.title')}`,
      meta: [
        { hid: 'robots', name: 'robots', content: 'noindex, nofollow' }
      ]
    }
  },
  computed: {
    statusCode () {
      return (this.error && this.error.statusCode) || 500
    }
  }
}
</script>

<style lang="scss" scoped>
.error-page {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  padding: 3rem 1.5rem;
}

.error-page__content {
  max-width: 1100px;
}

.error-page__code {
  margin-bottom: 1rem;
  color: $primary;
  font-size: clamp(5rem, 18vw, 6rem);
  font-weight: 700;
  line-height: 1;
}

.error-page .subtitle {
  margin: 1.5rem 0 2rem;
}
.button{
  font-weight: 600;
  margin-bottom: 12px;
}

</style>
